<form [formGroup]="form" (ngSubmit)="onSubmit()" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
    <div class="mt-6 mb-3">
        <h1 class="text-primary">Firma tu actualización de datos</h1>
    </div>

    <img src="img/enter-otp.png" class="w-auto h-52" alt="OTP">

    <p class="text-center text-gray-600 px-4">
        Para continuar, ingresa el código de verificación que enviamos a tu celular.
    </p>

    <hr class="w-full text-white">

    <!-- Contenedor para los 6 campos de código -->
    <div class="w-full flex justify-center space-x-2 px-4">
        <div
            class="w-12 h-12 flex justify-center items-center rounded-sm shadow-lg border border-blue-700 bg-white"
        >
            <input
                id="code1"
                type="tel"
                formControlName="code1"
                maxlength="1"
                (input)="onInput($event, 1)"
                (keypress)="onKeyPress($event)"
                (keydown)="onKeyDown($event, 1)"
                (paste)="onPaste($event)"
                class="border-none focus:outline-none focus:ring-0 rounded text-center w-full h-8 placeholder:text-gray-500 text-xl font-bold"
                autocomplete="one-time-code"
            />
        </div>
        <div
            class="w-12 h-12 flex justify-center items-center rounded-sm shadow-lg border border-blue-700 bg-white"
        >
            <input
                id="code2"
                type="tel"
                formControlName="code2"
                maxlength="1"
                (input)="onInput($event, 2)"
                (keypress)="onKeyPress($event)"
                (keydown)="onKeyDown($event, 2)"
                class="border-none focus:outline-none focus:ring-0 rounded text-center w-full h-8 placeholder:text-gray-500 text-xl font-bold"
                autocomplete="one-time-code"
            />
        </div>
        <div
            class="w-12 h-12 flex justify-center items-center rounded-sm shadow-lg border border-blue-700 bg-white"
        >
            <input
                id="code3"
                type="tel"
                formControlName="code3"
                maxlength="1"
                (input)="onInput($event, 3)"
                (keypress)="onKeyPress($event)"
                (keydown)="onKeyDown($event, 3)"
                class="border-none focus:outline-none focus:ring-0 rounded text-center w-full h-8 placeholder:text-gray-500 text-xl font-bold"
                autocomplete="one-time-code"
            />
        </div>
        <div
            class="w-12 h-12 flex justify-center items-center rounded-sm shadow-lg border border-blue-700 bg-white"
        >
            <input
                id="code4"
                type="tel"
                formControlName="code4"
                maxlength="1"
                (input)="onInput($event, 4)"
                (keypress)="onKeyPress($event)"
                (keydown)="onKeyDown($event, 4)"
                class="border-none focus:outline-none focus:ring-0 rounded text-center w-full h-8 placeholder:text-gray-500 text-xl font-bold"
                autocomplete="one-time-code"
            />
        </div>
        <div
            class="w-12 h-12 flex justify-center items-center rounded-sm shadow-lg border border-blue-700 bg-white"
        >
            <input
                id="code5"
                type="tel"
                formControlName="code5"
                maxlength="1"
                (input)="onInput($event, 5)"
                (keypress)="onKeyPress($event)"
                (keydown)="onKeyDown($event, 5)"
                class="border-none focus:outline-none focus:ring-0 rounded text-center w-full h-8 placeholder:text-gray-500 text-xl font-bold"
                autocomplete="one-time-code"
            />
        </div>
        <div
            class="w-12 h-12 flex justify-center items-center rounded-sm shadow-lg border border-blue-700 bg-white"
        >
            <input
                id="code6"
                type="tel"
                formControlName="code6"
                maxlength="1"
                (input)="onInput($event, 6)"
                (keypress)="onKeyPress($event)"
                (keydown)="onKeyDown($event, 6)"
                class="border-none focus:outline-none focus:ring-0 rounded text-center w-full h-8 placeholder:text-gray-500 text-xl font-bold"
                autocomplete="one-time-code"
            />
        </div>
    </div>

    <button
        type="button"
        class="text-blue-600 underline disabled:text-gray-400 disabled:no-underline"
        [disabled]="seconds > 0"
        (click)="resendCode()"
    >
        Reenviar Código {{ seconds > 0 ? '(' + seconds + 's)' : '' }}
    </button>

    <button
        #submitButton
        type="submit"
        class="btn-primary mt-4 w-full mx-4"
        [disabled]="!isFormValid()"
    >
        Verificar Código
    </button>

</form>

@if (showModal()) {
    <app-modal class="text-center" (close)="closeModal()">
        <h2 class="text-xl font-bold text-blue-600">
            Código de Verificación
        </h2>
        <hr class="my-4 border-gray-300 w-full" />
        <img [src]="srcImg" alt="OTP" class="mx-auto">
        <p class="mt-4 text-gray-700 px-4">
            {{ message() }}
        </p>

        <button
            class="btn-secundary mt-6"
            (click)="closeModal()"
        >
            Aceptar
        </button>
    </app-modal>
}
